import React from "react";
import { Radio } from "antd";
import cx from "classnames";

const CustomRadio = ({ ...rest }) => {
  return <Radio.Group className={cx("radio-group", { "radio-group--go4rent-theme": "go4rent" })} {...rest} />;
};

export default CustomRadio;
